import React from 'react'
import { Button, withStyles } from '@material-ui/core'
import { styles } from 'asterX-UI/Pagination/pagination.styles'
import PropTypes from 'prop-types'
import { PaginationItem, usePagination } from '@material-ui/lab'
import clsx from 'clsx'
import { ArrowLeftIcon, ArrowRightIcon } from 'asterX-UI/Icons'

function defaultGetAriaLabel(type, page, selected) {
  if (type === 'page') {
    return `${selected ? '' : 'Go to '}page ${page}`
  }
  return `Go to ${type} page`
}

const Pagination = React.forwardRef(function Pagination(props, ref) {
  const {
    boundaryCount,
    classes,
    className,
    color = 'standard',
    count,
    isMobile = false,
    defaultPage,
    disabled,
    getItemAriaLabel = defaultGetAriaLabel,
    hideNextButton,
    hidePrevButton,
    onChange,
    page,
    renderItem = item => <PaginationItem {...item} />,
    shape = undefined,
    showFirstButton,
    showLastButton,
    siblingCount,
    variant = 'text',
    setLoading,
    ...other
  } = props

  const { items } = usePagination({
    ...props,
    componentName: 'Pagination'
  })
  // "previous" next
  const { previous, next } = items
    ?.filter(item => item.type === 'previous' || item.type === 'next')
    ?.reduce((obj, cur) => ({ ...obj, [cur.type]: cur }), {})

  const otherItems = items?.filter(item => item.type !== 'previous' && item.type !== 'next')
  return (
    <div>
      <nav aria-label="pagination navigation" className={clsx(classes.root, className)} ref={ref} {...other}>
        <div>
          {isMobile ? (
            <PaginationItem {...previous} variant="outlined" />
          ) : (
            <div className={classes.previousButtonContainer}>
              <Button {...previous} className={classes.previousButton}>
                <ArrowLeftIcon />
                Предыдущая
              </Button>
            </div>
          )}
        </div>
        {isMobile ? (
          <div className={classes.countPages}>{`Страница ${page || 0} из ${count || 0} `}</div>
        ) : (
          <div className={classes.centerContent}>
            <ul className={classes.ul}>
              {otherItems.map((item, index) => (
                <li key={index}>
                  {renderItem({
                    ...item,
                    color,
                    'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
                    shape,
                    size: 'large',
                    variant
                  })}
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className={classes.content}>
          {isMobile ? (
            <PaginationItem {...next} variant="outlined" ic />
          ) : (
            <Button {...next} className={classes.nextButton}>
              Следующая <ArrowRightIcon />
            </Button>
          )}
        </div>
      </nav>
    </div>
  )
})

// @default tags synced with default values from usePagination

Pagination.propTypes = {
  boundaryCount: PropTypes.number,
  classes: PropTypes.object,
  className: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'secondary', 'standard']),
  count: PropTypes.number,
  defaultPage: PropTypes.number,
  disabled: PropTypes.bool,
  isMobile: PropTypes.bool,
  getItemAriaLabel: PropTypes.func,
  hideNextButton: PropTypes.bool,
  hidePrevButton: PropTypes.bool,
  onChange: PropTypes.func,
  page: PropTypes.number,
  renderItem: PropTypes.func,
  shape: PropTypes.oneOf(['round', 'rounded']),
  showFirstButton: PropTypes.bool,
  showLastButton: PropTypes.bool,
  siblingCount: PropTypes.number,
  size: PropTypes.oneOf(['large', 'medium', 'small']),
  variant: PropTypes.oneOf(['outlined', 'text'])
}

export default withStyles(styles, { name: 'MuiPagination' })(Pagination)
